// Pure field rules shared by the auth forms and Account settings. Each returns
// the message to show, or undefined when the value passes. "Required" only
// fires after a submit so a fresh form is not covered in red.

const EMAIL = /.+@.+\..+/

export function emailError(value: string, submitted: boolean): string | undefined {
  if (!value) return submitted ? 'Email is required' : undefined
  if (!EMAIL.test(value)) return 'Email must be valid'
  return undefined
}

/** Login only checks what the server would reject outright. */
export function loginPasswordError(value: string, submitted: boolean): string | undefined {
  if (!value) return submitted ? 'Password is required' : undefined
  if (value.length < 8) return 'Password must be at least 8 characters'
  return undefined
}

/** New passwords: length, case and a digit — the backend's rules. */
export function passwordStrengthError(value: string, submitted: boolean): string | undefined {
  if (!value) return submitted ? 'Password is required' : undefined
  if (value.length < 8) return 'Password must be at least 8 characters'
  if (!/[A-Z]/.test(value)) return 'Password must contain an uppercase letter'
  if (!/[a-z]/.test(value)) return 'Password must contain a lowercase letter'
  if (!/\d/.test(value)) return 'Password must contain a digit'
  return undefined
}

export function confirmPasswordError(value: string, password: string, submitted: boolean): string | undefined {
  if (!value) return submitted ? 'Please confirm your password' : undefined
  if (value !== password) return 'Passwords do not match'
  return undefined
}
